module.exports = __webpack_public_path__ + "img/ikon_havsborstmask.2eb4e4c0.svg";